// eslint-disable-next-line import/no-anonymous-default-export
export default {
  api : { urlBase: "http://lab-api-bq.herokuapp.com"}
}